// 该指令用于判断值是否在区间内  只要在区间外则会设置指定样式
// 提供一个数组 value[0]-值  value[1]-温/湿度区间(Object对象 需要有max和min 否则返回空样式)  value[2]-color 或 borderColor (默认color)
import Vue from 'vue';
// 高于区间和低于区间的颜色
const higher = 'orange';
const lower = '#00b5fc';
// 在正常范围值
const normal = {};
// 附加样式
const extStyle = {
    fontWeight: 'bold'
    // borderStyle: 'solid',
    // borderWidth: '2px',
    // borderColor: 'transparent'
};
let style;

Vue.directive('range', {
    inserted(el, binding, vnode) {
        const { value } = binding;
        if (value instanceof Array) {
            const attrs = getStyle(parseFloat(value[0]), value[1], value[2]);
            // 先将其style样式保存下来 等待更新时需要设置原样式
            style = el.getAttribute('style');

            Object.keys(attrs).forEach(key => {
                el.style[key] = attrs[key];
            });
        }
    },
    update(el, binding) {
        const { value, oldValue } = binding;
        if (value instanceof Array) {
            if (value[0] === oldValue[0]) return;
            el.setAttribute('style', style);
            const attrs = getStyle(parseFloat(value[0]), value[1], value[2]);
            Object.keys(attrs).forEach(key => {
                el.style[key] = attrs[key];
            });
        }
    }
});

function getStyle(val = 0, range, attr = 'color') {
    if (!range || range.max === undefined || range.max === '' || !val) return normal;
    range.max = parseFloat(range.max);
    range.min = parseFloat(range.min);

    // 如果是背景色更改 需要变为白色
    if (attr === 'background' || attr === 'backgroundColor') {
        extStyle.color = 'white';
    }
    if (val > range.max) {
        // 大于区间
        return {
            ...extStyle,
            [attr]: higher
        };
    } else if (val < range.min) {
        // 低于区间
        return {
            ...extStyle,
            [attr]: lower
        };
    }
    return {};
}
